export const blockIconsHardwareSmartToy = (
	<span className='material-symbols-outlined'>smart_toy</span>
);
